var exports = {
  "iE": "xdbfd91f1--60797c--wrapper",
  "M6": "xdbfd91f1--60797c--slide",
  "iX": "xdbfd91f1--60797c--video_slide",
  "pU": "xdbfd91f1--60797c--iframe",
  "ez": "xdbfd91f1--60797c--no_interface",
  "VH": "xdbfd91f1--60797c--preview",
};

module.exports = exports;
